import React, { useEffect } from 'react';
import { useApp } from '../../context/AppContext';
import useContentPreloader from '../../hooks/useContentPreloader';
import HomeScreen from '../views/HomeScreen/HomeScreen';
import BoardingPassFlow from '../views/BoardingPassFlow/BoardingPassFlow';
import Game1 from '../views/Game1/Game1';
import Game2 from '../views/Game2/Game2';
import Game3 from '../views/Game3/Game3';
import LoadingScreen from '../common/LoadingScreen/LoadingScreen';
import TransitionWrapper from '../common/TransitionWrapper/TransitionWrapper';
import './ViewManager.scss';

const ViewManager = () => {
  const { state, actions } = useApp();
  const { currentView, contentLoaded } = state;
  const { loading: contentLoading, error: contentError } =
    useContentPreloader();

  useEffect(() => {
    if (!contentLoaded && !contentLoading && !contentError) {
      actions.setContentLoaded(true);
    }
  }, [contentLoaded, contentLoading, contentError, actions]);

  if (!contentLoaded || contentLoading) {
    return <LoadingScreen message="Loading experience..." />;
  }

  if (contentError) {
    return (
      <div className="view-manager__error">
        <h2>Unable to load experience</h2>
        <p>Please check your connection and try again.</p>
        <button onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  }

  const renderCurrentView = () => {
    switch (currentView) {
      case 'home':
        return <HomeScreen />;
      case 'boarding-pass-flow':
        return <BoardingPassFlow />;
      case 'game-1':
        return <Game1 />;
      case 'game-2':
        return <Game2 />;
      case 'game-3':
        return <Game3 />;
      default:
        return <HomeScreen />;
    }
  };

  return (
    <div className="view-manager">
      <TransitionWrapper key={currentView}>
        {renderCurrentView()}
      </TransitionWrapper>
    </div>
  );
};

export default ViewManager;
